import { CustomField } from '../../../../models/response-new-link';

export const generatefield = (key: string): CustomField => {
	return fieldsOptionals(key);
};

export const fieldsOptionals = (key: string): CustomField => {
	if (key === 'rut') {
		return {
			key,
			label: 'Rut',
			placeholder: '00.000.000-X',
			required: false,
			type_var: 'TEXT',
			type: 'TEXT',
		};
	}
	if (key === 'names') {
		return {
			key,
			label: 'Nombre y apellido',
			placeholder: 'Maria Alvarado',
			required: false,
			type_var: 'TEXT',
			type: 'TEXT',
		};
	}

	return {
		key,
		label: 'Correo electrónico',
		placeholder: 'maria.alvarado@gmail.com',
		required: false,
		type_var: 'EMAIL',
		type: 'TEXT',
	};
};
